import { LebeledInput } from "./lib/LabeledInput.js"
import { I18N } from "./I18N.js"
import { DateHelper } from "./lib/DateHelper.js"
import { OpeningHourHelper } from "./OpeningHourHelper.js"
import { Toast } from "./Toast.js"

export class OrderSchedule {
	_target
	_idSuffix = '_' + new Date().getTime()
	_filterImmediatelyRb
	_filterLaterRb
	_filterDeliveryDaySelectorGroup
	_filterDeliveryDaySelector
	_filterDeliveryTimeSelector
	_onSetOrderScheduleHandlers = []
	_onSetExpandedHandlers = []
	_stores
	_schedule
	_scheduleOptions

	constructor(target) {
		this._target = document.getElementById(target)
		this._target.innerHTML = `<legend i18n>Time</legend>
			${LebeledInput.create(`<label for="filterImmediatelyRb${this._idSuffix}" i18n>Immediately</label>`, `<input type="radio" id="filterImmediatelyRb${this._idSuffix}" name="filterTiming" checked>`, true)}
			${LebeledInput.create(`<label for="filterLaterRb${this._idSuffix}" i18n>Later</label>`, `<input type="radio" id="filterLaterRb${this._idSuffix}" name="filterTiming">`, true)}
			<div id="filterDeliveryDaySelectorGroup${this._idSuffix}" class="field-group" hidden>
				${LebeledInput.create(`<label for="filterDeliveryDaySelector${this._idSuffix}">Day</label>`, `<select id="filterDeliveryDaySelector${this._idSuffix}" class="smallSelect"></select>`, false)}
				${LebeledInput.create(`<label for="filterDeliveryTimeSelector${this._idSuffix}">Time</label>`, `<select id="filterDeliveryTimeSelector${this._idSuffix}" class="smallSelect"></select>`, false)}
			</div>`

		this._filterDeliveryDaySelectorGroup = document.getElementById('filterDeliveryDaySelectorGroup' + this._idSuffix)

		this._filterImmediatelyRb = document.getElementById('filterImmediatelyRb' + this._idSuffix)
		this._filterImmediatelyRb.addEventListener('change', ev => {
			if (ev.currentTarget.checked) {
				this._filterDeliveryDaySelectorGroup.setAttribute('hidden', '')
				this._onSetOrderScheduleHandlers.forEach(handler => handler(null))
			}
		})
		this._filterLaterRb = document.getElementById('filterLaterRb' + this._idSuffix)
		this._filterLaterRb.addEventListener('change', ev => {
			if (ev.currentTarget.checked) {
				const now = new Date()
				const nextOpeningDate = OpeningHourHelper.snapNext(now, 30)
				const latestSchedule = new Date(now.getTime())
				latestSchedule.setHours(latestSchedule.getHours() + 36)
				const scheduleOptions = OpeningHourHelper.getSchedules(nextOpeningDate, latestSchedule, 30, this._stores, this._isDelivery)
				console.debug('Selectable schedules', scheduleOptions)
				this._schedule = scheduleOptions[0]
				this._updateScheduleOptions(scheduleOptions)
				this._filterDeliveryDaySelectorGroup.removeAttribute('hidden')
				this._onSetExpandedHandlers.forEach(handler => handler(true))
				this._onSetOrderScheduleHandlers.forEach(handler => handler(this._getSchedule()))
			}
		})

		this._filterDeliveryDaySelector = document.getElementById('filterDeliveryDaySelector' + this._idSuffix)
		this._filterDeliveryDaySelector.addEventListener('change', ev => {
			const dayName = ev.currentTarget.selectedOptions[0].value
			this._updateScheduleTimeOptions(dayName)
			this._onSetOrderScheduleHandlers.forEach(handler => handler(this._getSchedule()))
		})

		this._filterDeliveryTimeSelector = document.getElementById('filterDeliveryTimeSelector' + this._idSuffix)
		this._filterDeliveryTimeSelector.addEventListener('change', ev => {
			this._onSetOrderScheduleHandlers.forEach(handler => handler(this._getSchedule()))
		})

		I18N.translateElement(this._target)
	}

	/**
	 * 
	 * @param {*} stores A list of stores with opening hours and delivery times
	 */
	setStores = stores => this._stores = stores

	/**
	 * 
	 * @param {*} deliveryType Can be 'delivery', 'deliveryGps' or 'pckup'|null
	 */
	setDeliveryType = deliveryType => this._isDelivery = deliveryType === 'delivery' || deliveryType === 'deliveryGps'

	/**
	 * 
	 * @param {*} schedule A desired schedule Date or null for now
	 * @returns 
	 */
	setSchedule = schedule => {
		this._schedule = schedule
	}

	addOnSetOrderScheduleHandlers = (...onSetOrderScheduleHandlers) => this._onSetOrderScheduleHandlers.push(...onSetOrderScheduleHandlers)

	addSetExpandedHandlers = (...onSetExpandedHandlers) => this._onSetExpandedHandlers.push(...onSetExpandedHandlers)

	init = () => {
		console.debug('Is delivery', this._isDelivery)
		// const now = new Date('2023-02-12T11:00:00')
		// console.warn('Now is fixed to', now)
		const now = new Date()
		if (this._schedule) {
			console.debug('LocalStorage.schedule is', this._schedule)
			if (OpeningHourHelper.isInFuture(this._schedule, now, this._isDelivery ? 30 : 15)) {
				console.debug('Is in Future', this._schedule)
				if (OpeningHourHelper.areStoresOpen(this._stores, this._isDelivery, this._schedule, true)) {
					console.debug('There are open stores at', this._schedule)
					this._onSetExpandedHandlers.forEach(handler => handler(true))
					const nextOpeningDate = OpeningHourHelper.snapNext(now, 30)
					const latestSchedule = new Date(now.getTime())
					latestSchedule.setHours(latestSchedule.getHours() + 36)
					const scheduleOptions = OpeningHourHelper.getSchedules(nextOpeningDate, latestSchedule, 30, this._stores, this._isDelivery)
					console.debug('Selectable schedules', scheduleOptions)
					this._filterLaterRb.checked = true
					this._filterDeliveryDaySelectorGroup.removeAttribute('hidden')
					this._updateScheduleOptions(scheduleOptions)
					this._selectScheduleOption(this._schedule)
				}
				else {
					console.debug('There are no open stores at', this._schedule)
					if (OpeningHourHelper.areStoresOpen(this._stores, this._isDelivery, now, false)) {
						console.debug('There are open stores now')
						this._filterImmediatelyRb.checked = true
						this._filterDeliveryDaySelectorGroup.setAttribute('hidden', '')
						this._schedule = null
						this._filterDeliveryDaySelector.selectedIndex = -1
						this._filterDeliveryTimeSelector.selectedIndex = -1
					}
					else {
						console.debug('There are no open stores now')
						const nextOpeningDate = OpeningHourHelper.snapNext(now, 30)
						const latestSchedule = new Date(now.getTime())
						latestSchedule.setHours(latestSchedule.getHours() + 36)
						const scheduleOptions = OpeningHourHelper.getSchedules(nextOpeningDate, latestSchedule, 30, this._stores, this._isDelivery)
						console.debug('Selectable schedules', scheduleOptions)
						this._schedule = scheduleOptions[0]
						this._updateScheduleOptions(scheduleOptions)
						this._filterLaterRb.checked = true
						this._filterDeliveryDaySelectorGroup.removeAttribute('hidden')
						this._onSetExpandedHandlers.forEach(handler => handler(true))
					}
				}
			}
			else {
				console.debug('Is not in Future', this._schedule)
				if (OpeningHourHelper.areStoresOpen(this._stores, this._isDelivery, now, false)) {
					console.debug('There are open stores now')
					this._filterImmediatelyRb.checked = true
					this._filterDeliveryDaySelectorGroup.setAttribute('hidden', '')
					this._schedule = null
					this._filterDeliveryDaySelector.selectedIndex = -1
					this._filterDeliveryTimeSelector.selectedIndex = -1
				}
				else {
					console.debug('There are no open stores now')
					const nextOpeningDate = OpeningHourHelper.snapNext(now, 30)
					const latestSchedule = new Date(now.getTime())
					latestSchedule.setHours(latestSchedule.getHours() + 36)
					const scheduleOptions = OpeningHourHelper.getSchedules(nextOpeningDate, latestSchedule, 30, this._stores, this._isDelivery)
					console.debug('Selectable schedules', scheduleOptions)
					this._schedule = scheduleOptions[0]
					this._updateScheduleOptions(scheduleOptions)
					this._filterLaterRb.checked = true
					this._filterDeliveryDaySelectorGroup.removeAttribute('hidden')
					this._onSetExpandedHandlers.forEach(handler => handler(true))
				}
			}
		}
		else {
			console.debug('There is no LocalStorage.schedule')
			if (OpeningHourHelper.areStoresOpen(this._stores, this._isDelivery, now, false)) {
				console.debug('There are open stores now')
				this._filterImmediatelyRb.checked = true
				this._filterDeliveryDaySelectorGroup.setAttribute('hidden', '')
				this._schedule = null
				this._filterDeliveryDaySelector.selectedIndex = -1
				this._filterDeliveryTimeSelector.selectedIndex = -1
		}
			else {
				console.debug('There are no open stores now')
				new Toast('toaster', I18N.translate('No store is opened now'), Toast.INFO, 7)
				const nextOpeningDate = OpeningHourHelper.snapNext(now, 30)
				const latestSchedule = new Date(now.getTime())
				latestSchedule.setHours(latestSchedule.getHours() + 36)
				const scheduleOptions = OpeningHourHelper.getSchedules(nextOpeningDate, latestSchedule, 30, this._stores, this._isDelivery)
				console.debug('Selectable schedules', scheduleOptions)
				this._schedule = scheduleOptions[0]
				this._updateScheduleOptions(scheduleOptions)
				this._filterLaterRb.checked = true
				this._filterDeliveryDaySelectorGroup.removeAttribute('hidden')
				this._onSetExpandedHandlers.forEach(handler => handler(true))
			}
		}
		this._onSetOrderScheduleHandlers.forEach(handler => handler(this._getSchedule()))
	}

	_updateScheduleOptions = options => {
		const now = new Date()
		// round to next 30 minutes
		const earliest = new Date((Math.ceil(now.getTime() / (1000 * 60 * 30)) * (1000 * 60 * 30)) + (1000 * 60 * 30))
		console.log(earliest)
		let scheduleOptions = options
		if (!scheduleOptions) {
			scheduleOptions = []
			for (let i = 0; i < 48; i++) {
				const schedule = new Date(earliest.getTime())
				schedule.setMinutes(earliest.getMinutes() + i * 30)
				if (schedule.getHours() >= 12 || (schedule.getHours() <= 1 && schedule.getMinutes() <= 1)) {
					// console.log(schedule)
					scheduleOptions.push(schedule)
				}
			}
		}

		const dayOptions = []
		scheduleOptions.forEach(s => {
			const day = DateHelper.DAYS_OF_WEEK[s.getDay()]
			if (!dayOptions.some(o => o.day === day)) {
				dayOptions.push({ date: `${DateHelper.getIsoFormatOfDate(s)}`, day: day })
			}
		})
		const dayOptionsHtml = dayOptions.map(o => `<option value="${o.day}" date="${o.date}">${I18N.translate(o.day)}</option>`).join('')
		this._filterDeliveryDaySelector.innerHTML = dayOptionsHtml
		this._scheduleOptions = scheduleOptions
		if (dayOptions.length) {
			// Offer times for 1st day
			this._updateScheduleTimeOptions(dayOptions[0].day)
		}
	}

	_updateScheduleTimeOptions = dayName => {
		const day = DateHelper.DAY_INDICES[dayName]
		const optionsForDay = this._scheduleOptions.filter(o => o.getDay() === day)
		const timeOptionsHtml = optionsForDay.map(o => {
			const hourMinute = DateHelper.getHourMinuteOfDate(o)
			return `<option value="${hourMinute}:00">${hourMinute}</option>`
		}).join('')
		this._filterDeliveryTimeSelector.innerHTML = timeOptionsHtml
	}

	_selectScheduleOption = schedule => {
		this._filterDeliveryDaySelectorGroup.removeAttribute('hidden')
		const day = DateHelper.DAYS_OF_WEEK[schedule.getDay()]
		console.debug('Setting day to:', day)
		this._filterDeliveryDaySelector.value = day
		this._updateScheduleTimeOptions(day)
		const timeString = DateHelper.getHourMinuteOfDate(schedule) + ':00'
		console.debug('Setting time to:', timeString)
		this._filterDeliveryTimeSelector.value = timeString
	}

	/**
	 * Evaluate the selectors
	 * @returns The selected Date
	 */
	_getSchedule = () => {
		if (
			!this._filterDeliveryDaySelector.selectedOptions
			|| !this._filterDeliveryDaySelector.selectedOptions.length
			|| !this._filterDeliveryTimeSelector.selectedOptions
			|| !this._filterDeliveryTimeSelector.selectedOptions.length
		) {
			console.debug('No values selected')
			return null
		}
		const dateOption = this._filterDeliveryDaySelector.selectedOptions[0]
		const hourMinuteOption = this._filterDeliveryTimeSelector.selectedOptions[0]
		const localDateString = `${dateOption.getAttribute('date')}T${hourMinuteOption.getAttribute('value')}`
		console.debug('Date selected: ', localDateString)
		return new Date(localDateString)
	}

}